import * as api from './../api'
import moment from "moment"

const state = {
    data: []
}

const getters = {}

const mutations = {
    save(state, data) {
        state.data = data
    },
    panggil(state, data) {
        let found = state.data.find(k => k.id_siswa == data.id_siswa);
        found.waktu_dipanggil = moment().format('YYYY-MM-DD HH:ii:ss');

        api
        .postJson("/v1/wisuda/CheckinController/panggil", {
          id: found.id_wisuda,
        })
    },
    sertifikat(state, data) {
        let found = state.data.find(k => k.id_siswa == data.id_siswa);
        found.waktu_ambil_sertifikat = moment().format('YYYY-MM-DD HH:ii:ss');

        api
        .postJson("/v1/wisuda/CheckinController/sertifikat", {
          id: found.id_wisuda,
        })
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/peserta.js